import { Injectable } from '@angular/core';
import { AffiliateTrackerInterface, AffiliateTrackerCallbackParams } from 'src/app/interfaces/affliation-interface';
import { MetapixelService } from './metapixel.service';

@Injectable({
    providedIn: 'root'
  })
export class MetaPixelTracker 
    implements AffiliateTrackerInterface
{
    protected params: any;
    
    constructor(
        private metaPixel: MetapixelService,
    ) {   }
    
    initialize(): Promise<AffiliateTrackerInterface> {      
        this.metaPixel.setup();
        return Promise.resolve( this);
    }
    
    login( cbParams: AffiliateTrackerCallbackParams) {  }
    signupStep1Complete( cbParams: AffiliateTrackerCallbackParams) {  }
    signupComplete( cbParams: AffiliateTrackerCallbackParams) {  }
    deposit( cbParams: AffiliateTrackerCallbackParams) {  }
    withdraw( cbParams: AffiliateTrackerCallbackParams) {  }
    gameLaunched( cbParams: AffiliateTrackerCallbackParams) {  }
    registerSubmitted( ) {  }
    registerSuccess( ) {  }
}